module.exports = __webpack_public_path__ + "images/50a965ca7dded6485f1f5dd41c879856-logo.png";